import reducer from './reducer'

import * as loanMergesOperations from './operations'
import * as loanMergesSelectors from './selectors'

export { loanMergesOperations, loanMergesSelectors }

export default reducer